import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, switchMap, takeUntil } from 'rxjs';
import { BreadcrumbService } from 'src/app/core/services/breadcrumb/breadcrumb.service';
import { SeoService } from 'src/app/shared/services/seo-service/seo.service';
import { SeoJsonLdService } from 'src/app/core/services/seoJsonLd/seoJsonLd.service';
import { QuestionList } from 'src/app/shared/models/questionList';
import { FaqsDataLayer } from 'src/app/shared/models/seo/faqsDataLayer';
import { NavigatorService } from 'src/app/shared/services/navigator/navigator.service';

@Component({
  selector: 'app-questionList',
  templateUrl: './questionList.component.html',
})
export class QuestionListComponent implements OnDestroy {
  questionList!: QuestionList;
  isSearchDisabled!: boolean;
  private destroyed$ = new Subject<void>();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
    private faqsDataLayer: FaqsDataLayer,
    private navigatorService: NavigatorService,
    private seoJsonLdService: SeoJsonLdService,
    private seoService: SeoService,
    private translateService: TranslateService,
  ) {
    this.activatedRoute.data
      .pipe(
        switchMap(data => {
          this.questionList = data['questionList'];
          this.breadcrumbService.setBreadcrumb({
            parentId: this.questionList?.parentId,
            name: this.questionList?.breadcrumb,
            type: 'faqsQuestionList',
            id: this.questionList?.sys?.id,
          });
          this.setDatalayerValues();
          this.navigatorService.setDynamicTitle(this.questionList.breadcrumb);
          this.seoJsonLdService.createJsonLdScriptQuestionList(
            this.questionList,
          );
          const topic = this.seoService.normalizeContentfulTitle(
            this.questionList.title,
          );
          return this.translateService.get('SEO.META.DESCRIPTION.TOPIC', {
            topic,
          });
        }),
        takeUntil(this.destroyed$),
      )
      .subscribe(metaDescription =>
        this.seoService.updateDescriptionMetaTag(metaDescription),
      );
    this.isSearchDisabled = this.navigatorService.isSearchDisabled;
  }

  ngOnDestroy(): void {
    this.destroyed$?.next();
    this.destroyed$?.complete();
  }

  private setDatalayerValues(): void {
    this.faqsDataLayer.setData(
      this.questionList.breadcrumb,
      this.questionList.publicPrivateModel,
    );

    this.questionList.faqItemCollection.items.forEach((item: any) => {
      this.faqsDataLayer.setSubElement(
        item.title,
        item.publicPrivateModel,
        item.vertical,
      );
    });
    this.faqsDataLayer.saveData(window);
  }

  onQuestionClicked(event: any): void {
    const { item } = event;
    this.router.navigate([`${item.slug}`], { queryParamsHandling: 'preserve' });
  }
}
